/* eslint-disable */
import React from 'react';
import Enc from '../Enc/Enc';
import GError from '../Error/error';
import ArcApi from '../api/ArcApiCls';
import Storage from '../storage/storage';
import BaseServices from './base-service.js';
import ErrorComponent from '../../components/error';

function getGAuth() {
  let loginInfo = localStorage.getItem('loginInfo');
  try {
    loginInfo = JSON.parse(loginInfo);
  } catch (e) {
    loginInfo = '';
  }

  const gauth = { SID: '', token: '' };
  if (loginInfo) {
    let { SID, token } = loginInfo.session;
    gauth.SID = SID;
    gauth.token = token;
  }
  return gauth;
}

const UserInfo = Storage.getUser();

export default class Services {
  static reqData({ data }) {
    return Services.Req({ data });
  }

  static getData({ data }) {
    return Services.Req({ data });
  }

  static postData({ data }) {
    return Services.Post({ data });
  }

  static async createReq(inputs) {
    const { noCache = false } = inputs;
    const { url, enc, sign } = Services.getQueryEnc(inputs);

    try {
      return await BaseServices.post({
        url:
          url +
          sign +
          '/ping.gpng' +
          `${!noCache ? '' : `?noCache=${new Date().getTime()}`}`,
        query: { ICON_NAME: enc },
      });
    } catch (e) {
      // console.log(e);
    }

    /*   if (enc.length < 800) {
      try {
        const newUrl = `${url}${sign}/${enc}.gpng${
          !noCache ? "" : `?noCache=${new Date().getTime()}`
        }`;
        return await BaseServices.get({url: newUrl, query: {}});
      } catch (e) {
        // console.log(e);
      }
    } else {
      return BaseServices.post({
        url:
          url +
          sign +
          "/ping.gpng" +
          `${!noCache ? "" : `?noCache=${new Date().getTime()}`}`,
        query: { ICON_NAME: enc },
      });
    }*/
  }

  static Req(inputs) {
    const { onLine, onCache, noCache = false, fullResult } = inputs;

    const { url, enc, sign, query } = Services.getQueryEnc(inputs);

    if (enc.length < 800) {
      return BaseServices.get({
        headers: { Accept: 'image/png' },
        url:
          url +
          sign +
          '/' +
          enc +
          '.gpng' +
          `${!noCache ? '' : `?noCache=${new Date().getTime()}`}`,
      })
        .then((result) => {
          return Services.afterSuccess({
            query,
            result,
            onLine,
            onCache,
            fullResult,
            request: inputs,
          });
        })
        .catch(() => {
          return BaseServices.post({
            headers: { Accept: 'image/png' },
            url:
              url +
              sign +
              '/ping.gpng' +
              `${!noCache ? '' : `?noCache=${new Date().getTime()}`}`,
            query: { ICON_NAME: enc },
          })
            .then((result) => {
              return Services.afterSuccess({
                query,
                result,
                onLine,
                onCache,
                fullResult,
                request: inputs,
              });
            })
            .catch((error) => {
              return Services.callErrorComponent(error);
            });
        });
    } else {
      return BaseServices.post({
        headers: { Accept: 'image/png' },
        url:
          url +
          sign +
          '/ping.gpng' +
          `${!noCache ? '' : `?noCache=${new Date().getTime()}`}`,
        query: { ICON_NAME: enc },
      })
        .then((result) => {
          return Services.afterSuccess({
            query,
            result,
            onLine,
            onCache,
            fullResult,
            request: inputs,
          });
        })
        .catch((error) => {
          return Services.callErrorComponent(error);
        });
    }
  }

  /*  static ReqHttp(inputs) {
    const { onLine, onCache, noCache = false, fullResult } = inputs;

    const query = Services.getQuery(inputs);

    if (query && query.length < 800) {
      return BaseServices.get({
        query,
        url: `${_baseUrl}/?HTTP_VIEWMODE=2&nocache=${new Date().getTime()}`,
      })
        .then((result) => {
          return Services.afterSuccess({
            query,
            result,
            onLine,
            onCache,
            fullResult,
            request: inputs,
          });
        })
        .catch(() => {
          return BaseServices.post({
            query: { ...query, HTTP_VIEWMODE: 2 },
            url: `${_baseUrl}/?HTTP_VIEWMODE=2&nocache=${new Date().getTime()}`,
          });
        })
        .then((result) => {
          return Services.afterSuccess({
            query,
            result,
            onLine,
            onCache,
            fullResult,
            request: inputs,
          });
        })
        .catch((error) => {
          return Services.callErrorComponent(error);
        });
    } else {
      return BaseServices.post({
        query: { ...query, HTTP_VIEWMODE: 2 },
        url: `${_baseUrl}/?HTTP_VIEWMODE=2&nocache=${new Date().getTime()}`,
      })
        .then((result) => {
          console.log(2, result);
          return Services.afterSuccessHTTP({
            query,
            result,
            onLine,
            onCache,
            request: inputs,
          });
        })
        .catch((error) => {
          return Services.callErrorComponent(error);
        });
    }
  }*/

  static Get(inputs) {
    const { onLine, onCache, fullResult } = inputs;
    const { url, enc, sign, query } = Services.getQueryEnc(inputs);
    return BaseServices.get({
      url: url + sign + '/' + enc + '.gpng',
    })
      .then((result) => {
        return Services.afterSuccess({
          query,
          result,
          onLine,
          onCache,
          fullResult,
        });
      })
      .catch((error) => {
        return Services.callErrorComponent(error);
      });
  }

  static Post(inputs) {
    const { onLine, onCache, noCache = false, fullResult } = inputs;
    const { url, enc, sign, query } = Services.getQueryEnc(inputs);

    if (_D == 1) {
      console.log(query);
    }

    return BaseServices.post({
      headers: { Accept: 'image/png' },
      url:
        url +
        sign +
        '/ping.gpng' +
        `${!noCache ? '' : `?noCache=${new Date().getTime()}`}`,
      query: { ICON_NAME: enc },
    })
      .then((result) => {
        return Services.afterSuccess({
          query,
          result,
          onLine,
          onCache,
          fullResult,
        });
      })
      .catch((error) => {
        return Services.callErrorComponent(error);
      });
  }

  static PostChain({
    data,
    onLine,
    onCache,
    noCache = false,
    fullResult,
  }: {
    data: { chain: object[] };
    onLine?: boolean;
    onCache?: boolean;
    noCache?: boolean;
    fullResult?: boolean;
  }) {
    const chain = [...data.chain];
    // @ts-ignore
    delete data.chain;

    const chainData = {
      INPUT_CHAIN: JSON.stringify(chain),
      CHAIN_COMMIT: '1',
    };

    const { url, enc, sign, query } = Services.getQueryEnc({ data: chainData });

    if (_D == 1) {
      console.log(query);
    }

    return BaseServices.post({
      url:
        url +
        sign +
        '/ping.gpng' +
        `${!noCache ? '' : `?noCache=${new Date().getTime()}`}`,
      query: {
        ICON_NAME: enc,
      },
    })
      .then((result) => {
        return Services.afterSuccess({
          query,
          result,
          onLine,
          onCache,
          fullResult,
          isChain: true,
          request: data,
        });
      })
      .catch((error) => {
        if (_D == 1) {
          console.error(error);
        }
        return Services.callErrorComponent(error);
      });
  }

  static getQueryEnc({ data }) {
    let query = Services.getQuery({ data });

    if (!UserInfo.invalidToken) {
      query['JWT'] = Storage.getToken();
    }

    const url = `${_baseUrl}/ARC-File/`;

    const { enc, sign } = Enc.encAESForARC({ query });

    return { url, enc, sign, query };
  }

  static upload({ data, path }) {
    const url = `${_baseUrl}/?app=admin&view=upload&path=${path}&gprojects[PID]=${_PID}&gprojects[CID]=${_CID}&gprojects[LNUM]=${_LNUM}&HTTP_VIEWMODE=1`;
    return BaseServices.request({
      method: 'post',
      url,
      data,
    })
      .then((result) => {
        const res = result.data['ARC'][_PID]['app'];
        return Promise.resolve(res);
      })
      .catch((error) => {
        if (error.response) {
          return Promise.resolve({ error: error.response });
        }
        return Promise.resolve({ error });
      });
  }

  static getQuery({ data }) {
    const gauth = getGAuth();
    const LANG = Storage.getLanguage();
    const currency = Storage.getStorage({ key: 'currency' });
    // data = { ...data, LANG };
    data = { ...data, HL: LANG, CC: currency };

    if (gauth.SID) {
      data = { ...data, ...{ gauth } };
    }

    const gprojects = { PID: _PID, CID: _CID, LNUM: _LNUM };
    data = { ...data, gprojects };

    return data;
  }

  static async afterSuccess({
    query,
    result,
    onLine,
    onCache,
    isChain,
    request,
    fullResult = false,
  }) {
    const data = Services.EncodeResponse({ result, onLine, onCache });

    let parsData;
    try {
      parsData = JSON.parse(data);
    } catch (e) {}

    if (
      parsData &&
      parsData._Session &&
      parsData._Session.user &&
      parsData._Session.user.loggedIn === false
    ) {
      const userInfo = Storage.getUser();
      const token = Storage.getToken();
      const extender = Storage.getExtender();

      if (extender && !userInfo.invalidToken) {
        try {
          const result = await Services.createReq({
            data: {
              app: 'users',
              view: 'getLoginToken',
              JWEX: extender,
              JWT: token,
            },
          });
          let authData = Services.EncodeResponse({
            result: result,
            onLine,
            onCache,
          });
          try {
            authData = JSON.parse(authData);
            const res = ArcApi.getResponse({
              result: authData,
              PID: _PID,
              fullResult,
            });
            if (res.error) {
              Storage.addToUser({ key: 'invalidToken', value: true });
              Storage.removeExtender();
              Storage.logoutStorage();
              window.location.href = '/ARC/users/login';
            } else {
              if (!isChain) {
                Services.Req(request);
              } else {
                Services.PostChain(request);
              }
            }
            //todo:add here
          } catch (e) {}
        } catch (e) {
          // console.log(e);
          // console.log(e.message);
        }
      }
    }
    const { ARC, _Status: status } = parsData;

    let response;
    if (fullResult) {
      response = parsData;
    } else if (
      status &&
      status.ARC &&
      status.ARC[_PID] &&
      status.ARC[_PID].app &&
      status.ARC[_PID].app.status === 'success'
    ) {
      response = ARC[_PID].app;
    } else {
      response = ARC[_PID].app && ARC[_PID].app;
    }

    if (_D === 1) {
      console.group('API');
      console.log(query);
      console.log(parsData);
      console.groupEnd();
    }
    const err = GError.checkError(response);
    if (!err) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response.error);
    }
  }

  static EncodeResponse({ result, onLine, onCache }) {
    const data = Services.getARCFileData(result);
    const parseData = JSON.parse(data);
    const SystemTime = parseData._Render.until;
    const header = result.headers;
    localStorage.setItem('SystemTime', SystemTime);
    if (header?._swstate === 'CACHE') {
      onCache?.();
    } else if (!header?._swstate || header?._swstate === 'ONLINE') {
      onLine?.();
    }

    return data;
  }

  static getARCFileData({ data }) {
    try {
      const splitter = data.substr(data.length - 3);
      const array = data.split(splitter);
      let enc = array[1];
      enc = enc.split('-><ARC!>')[0];
      return Enc.decAESForARC({ enc });
    } catch (e) {}
  }

  static callErrorComponent(obj) {
    if (obj && obj.code === 'ERR_NETWORK') {
      obj.code = '-100';
    }
    return {
      error: obj,
      component: React.createElement(ErrorComponent, { ...obj }),
    };
  }

  static afterSuccessHTTP({ result }) {
    const { ARC, _Status: status } = result.data;
    if (
      status &&
      status.ARC &&
      status.ARC[_PID] &&
      status.ARC[_PID].app &&
      status.ARC[_PID].app.status === 'success'
    ) {
      if (ARC[_PID] && ARC[_PID].app) {
        return ARC[_PID] && ARC[_PID];
      }
    } else {
      return status.condition;
    }
  }
}
